/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'ramda';

import Skeleton from '../Base';

const ParagraphSkeleton = ({ length = 2, ...props }) => (
  <>
    <Skeleton key={0} {...props} />
    {range(1, length - 1).map((i) => (
      <Skeleton mt={2} key={i} {...props} />
    ))}
    <Skeleton mt={2} key={length} width="80%" {...props} />
  </>
);

ParagraphSkeleton.propTypes = {
  length: PropTypes.number,
};

export default ParagraphSkeleton;
